export default {
  //IP白名单设置
  systemWhiteSetting: {
    //columns searchColumns
    ip: 'IP',
    remake: 'thông báo',
    status: 'trạng thái',
    createTime: 'thời gian tạo',
    platformName: 'nền tảng bạn thuộc về',
    operate: 'thao tác',
    //placeholder
    placeholderIp: 'Nhập địa chỉ IP',
    placeholderRemake: 'Nhập ghi chú',
    placeholderStatus: 'Vui lòng nhập trạng thái',
    placeholderCorrectIp: 'IP vừa nhập sai định dạng',
    alertTitle: 'Quy tắc giao tiếp IP',
    alertDescription: 'Ví dụ: 192.168.8.1, 192.168.8.*, 192.168.8.0/24;* Indindicates 0-255, 0-24 Cho biết 0-24',
  },
  //日志管理
  systemLogs: {
    operatorUserName: 'người thao tác',
    operatorObjectName: 'người sử dụng',
    operatorTypeMsg: 'loại hình',
    operatorCode: 'đánh dấu nhật ký',
    operatorTime: 'thời gian thao tác',
    operatorIp: 'đăng nhập lần cuối',
    operatorContent: 'nội dung thao tác',
    url: 'yêu cầu URL',
    operatorAfter: 'dữ liệu mới',
    operatorPre: 'dữ liệu cũ',
    operate: 'thao tác',
  },
  //系统参数管理
  systemParams: {
    validateParametersTitle: 'Quản lý hậu đài cấu hình thông số mã xác minh',
    expiresParametersTitle: 'Cấu hình thông số thời gian hết hạn',
    rebateParametersTitle: 'Cài đặt tham số tỉ lệ hoàn',
    rebate_tmsv_dif: 'Tỉ lệ hoàn chênh lệch tối đa',
    rebate_max_value: 'chiết khấu tối đa',
    backstage_login: 'Mã xác minh đăng nhập',
    google_backstage_login: 'Mã xác minh đăng nhập Google',
    ip_whitelist_flag: 'Xác nhận đăng nhập danh sách đen IP',
    backstage_user_online_expire_time: 'hậu đài quản trị viên thời gian hết hạn trực tuyến người dùng web',
    minute: 'phút',
    dataName: '数据名称',
    retentionTime: '留存时间/分钟',
    remark: '备注',
  },
  //菜单管理
  systemNavManage: {
    parentId: 'menu cấp trên',
    name: 'tên menu',
    nameZh: 'tên trung quốc',
    nameEn: 'tên tiêng Anh',
    nameVie: 'tên việt nam',
    category: 'loại menu',
    path: 'địa chỉ định tuyến',
    source: 'biểu tượng menu',
    code: 'số menu',
    sort: 'sắp xếp menu',
    remark: 'Ghi chú menu',
    operate: 'thao tác',

    placeholderParentId: 'Chọn menu nhánh trên',
    placeholderCategory: 'Chọn loại hình menu',
    placeholderName: 'Nhập tên menu',
    placeholderNameZh: 'Nhập tên tiếng Trung cho menu',
    placeholderNameEn: 'Nhập tên tiếng Anh cho menu',
    placeholderNameVie: 'Nhập tên tiếng Việt cho menu',
    placeholderPath: 'Nhập địa chỉ định tuyến',
    placeholderSource: 'Chọn icon cho menu',
    placeholderCode: 'Nhập mã số menu',
    placeholderSort: 'Nhập số thứ tự cho menu',
    placeholderRemark: 'Nhập ghi chú trên menu',

    radioMenu: 'Menu',
    radioButton: 'Nút',
  },
  //游戏更新设置
  systemAppUpdateManage: {
    platformName: 'nền tảng bạn thuộc về',
    platformCode: 'Mã nền tảng',
    name: 'tên trò chơi',
    code: 'mã trò chơi',
    currentVersion: 'Phiên bản hiện tại',
    updateUserName: 'người thao tác',
    updateTime: 'thời gian thao tác',
    updateVersion: 'Cập nhật lên phiên bản',
    operate: 'thao tác',

    tipsText1: '1.Cập nhật nguồn phiên bản, vui lòng tải lên tệp nguồn trước;',
    tipsText2: '2.Cập nhật phiên bản nếu điền dữ liệu trùng khớp với phiên bản trước, thì xem như chưa cập nhật; ',
    tipsText3: 'Đưa tệp vào đây, hoặc',
    tipsText4: 'Bấm để tải lên',
    tipsText5: 'Chỉ tải lên các tệp zip và không quá 500MB',
    tipsText6: 'Địa chỉ lưu trữ nguồn vui lòng không tự thay đổi',
    uploadTitle: 'Tải lên tài nguyên đính kèm',
    gameHotterVersionTime: 'thời gian update',
    resourceStore: 'Địa chỉ lưu trữ nguồn',

    names: 'trò chơi',
    amount: 'Số lượng',
    placeholderVersion: 'Nhập số hiệu phiên bản',
    placeholderUpdateVersion: 'Nhập cập nhật đến phiên bản',
    placeholderResourceStore: 'Nhập địa chỉ lưu trữ nguồn',
    placeholderCorrectResourceStore: 'Nhập địa chỉ lưu trữ nguồn chính xác',
    commonMessage1: 'Chỉ được tải lên tệp zip',
    commonMessage2: 'Kích thước tệp không được quá 500MB!',
    commonMessage3: 'Chỉ được phép tải lên 1 tệp',
    commonMessage4: 'Số hiệu phiên bản sai định dạng',
    commonMessage5: 'Số hiệu phiên bản không được để trống',
  },
  systemServerUpdateManage: {
    name: 'tên trò chơi',
    code: 'mã trò chơi',
    updateUserName: 'người thao tác',
    updateTime: 'thời gian thao tác',
    peopleNum: 'Số người đang chơi）',
    status: "Trạng thái",
    operate: 'thao tác',

  },
  //内测账号
  systemUserManagePrivateAccount: {
    account: 'tài khoản',
    balance: 'Số dư trong tài khoản',
    password: 'mật khẩu đăng nhập',
    operate: 'thao tác',

    placeholderAccount: 'Nhập tên tài khoản',
    placeholderPassword: 'Nhập mật khẩu đăng nhập',
    placeholderBalance: 'Nhập số dư tài khoản',
  },
  //后台用户列表
  systemUserManage: {
    account: 'tài khoản',
    name: 'Tên hiển thị',
    realName: 'họ tên người dùng',
    avatar: 'ảnh đại diện',
    roleName: 'thuộc về nhân vật',
    managePlatformName: 'Nền tảng ủy quyền',
    secretKey: 'Khóa Google',
    password: 'mật khẩu đăng nhập',
    password2: 'thông tin cơ bản',
    verifyState: '验证状态',
    verifyState1: '开启',
    verifyState2: '关闭',
    lockFlag: '状态',
    lockFlag2: '正常',
    lockFlag3: '锁定',
    operate: 'thao tác',

    placeholderAccount: 'Nhập tên tài khoản',
    placeholderPassword: 'Nhập mật khẩu đăng nhập',
    placeholderName: 'Nhập biệt danh tài khoản',
    placeholderRealName: 'Nhập họ tên người dùng',
    placeholderRoleName: 'Chọn cấp bậc của bạn',
    placeholderManagePlatformName: 'Chọn nền tảng ủy quyền',
  },
  //角色管理
  systemRoleManage: {
    code: 'Mã cấp bậc）',
    name: 'tên nhân vật',
    sort: 'loại',
    operate: 'thao tác',

    permission: 'Quyền hạn của bạn',
    placeholderCode: 'Nhập mã số cấp bậc',
    placeholderName: 'Nhập tên cấp bậc',
    placeholderSort: 'Nhập số thứ tự menu',
    placeholderMenu: 'Chọn menu muốn ủy quyền',
  },
  //平台管理
  systemPlatformManage: {
    code: 'Mã nền tảng',
    name: 'Tên nền tảng',
    contact: 'liên hệ',
    mobileNumber: 'điện thoại',
    domain: 'Tên miền ràng buộc',
    customerServiceUrl: '客服地址',
    pumpingRatio: '盈亏抽成比例',
    gamePumpingRatio: '游戏抽成比例',
    sort: 'loại',
    secretKey: 'Khóa AES',
    md5Key: 'Khóa MD5',
    type: '平台控盘类型',
    type1: '控盘',
    type2: '非控盘',
    account: 'tài khoản',
    password: 'mật khẩu đăng nhập',
    password2: 'thông tin cơ bản',
    googleSecurityCode: '谷歌验证码',
    operate: 'thao tác',

    game: 'Trò chơi của bạn',
    verify: 'Kiểm tra',
    messageBox: 'Không được xóa nền tảng mặc định trên hệ thống',
    placeholderCode: 'Nhập mã nền tảng',
    placeholderCode2: 'Mã code đã tồn tại trên nền tảng',
    placeholderName: 'Nhập tên nền tảng',
    placeholderSecretKey: 'Nhập khóa AES',
    placeholderMd5Key: 'Nhập khóa MD5',
    placeholderContact: 'Nhập người liên hệ',
    placeholderMobileNumber: 'Nhập số điện thoại liên hệ',
    placeholderDomain: 'Nhập tên miền cần thêm',
    placeholderCustomerServiceUrl: '请输入客服地址',
    placeholderPumpingRatio: 'Nhập tỉ lệ chiết khấu',
    placeholderGamePumpingRatio: '请输入游戏抽成比例',
    placeholderSort: 'Nhập số thứ tự',
    placeholderAccount: 'Nhập tài khoản người dùng',
    placeholderPassword: 'Nhập mật khẩu đăng nhập',
    placeholderGame: 'Chọn trò chơi muốn cài đặt',
    walletType: "Loại ví",
    singleWallet: "Ví đơn",
    transferWallet: "Ví chuyển khoản"
  },
  //敏感词管理
  systemSensitiveWord: {
    word: 'từ nhạy cảm',
    operate: 'thao tác',

    placeholderSensitiveWord: 'Để thêm hàng loạt vui lòng dùng "," để ngăn cách',
  },
  commonTitle: 'Không có gì để trở thành một nền tảng',
  // 对象存储
  systemResourceOss: {
    ossCode: "Mã nguồn",
    endpoint: "Địa chỉ nguồn",
    bucketName: "Biệt danh",
    status: "Trạng thái",
    option: "Thao tác",
    remark: "Ghi chú"
  },
  //第三方同步信息
  systemThirdPartySyncInfo: {
    platformCode: 'Thuộc nền tảng',
    id: 'ID',
    transferId: 'ID truyền dẫn',
    requestUrl: 'Tên miền',
    type: 'Loại hình',
    status: 'Trạng thái',
    retryCount: 'Số lần thử lại',
    beginTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    lastReqTime: 'Thời gian gửi yêu cầu lần cuối',
    lastRespTime: 'Thời gian gửi phản hồi lần cuối',
    nextReqTime: 'Thời gian gửi yêu cầu lần sau',
    jsonStr: 'Thông tin yêu cầu',
    errStr: '返回信息',
    datetime: 'Thời gian',
    operate: 'Thao tác',
    succeed: 'Thành công',
    fail: 'Thất bại',
    all: 'Tất cả',
    userAccount: 'Tên tài khoản',
    expenses: 'Đặt cược',
    income: 'Trả thưởng',
    refund: 'Hoàn lại',
    frozen: 'Đóng băng',
    thaw: 'Hết đóng băng',
    cancel: 'Hủy đơn',
    settle: 'Giải quyết',
    sum: 'Kiểm tiền',
    adjust: 'Tiền thưởng chương trình',
    auditStatus: 'Trạng thái kiểm duyệt',
    auditRemark: 'Ghi chú kiểm duyệt',
    tabsMongodb: 'Số liệu thực',
    tabsEs: 'Lưu báo cáo',
    radioAuditStatus1: 'Chưa kiểm duyệt',
    radioAuditStatus2: 'Đã kiểm duyệt',
    remark1: 'Lưu ý: Thành công trong hơn 3 phút',
    remark2: 'Lưu ý: Chỉ giữ bản ghi 3 phút và bản ghi bất thường mới nhất',
    message1: 'Xác nhận số tiền này ở bên thứ 3',
    message2: 'Không có số tiền này ở bên thứ 3',
    message3: 'Khi trạng thái không thành công mới có thể thao tác hàng loạt',
    message4: 'Thử lại thành công',
    message5: 'Thử lại không thành công',
    message6: 'Hủy đơn thành công',
    message7: 'Hủy đơn không thành công',
    searchRemark: '(Nhập null biểu thị tìm kiếm tài khoản người dùng để trống)',
    oId: 'Oid',
    orderMsg: 'OrderMsg',
    retryStatus1: 'Chờ thử lại',
    retryStatus2: 'Thử lại thành công',
    retryType1: 'Hết đóng băng',
    retryType2: 'SQL hàng loạt thất bại',
    retryType3: 'Yêu cầu hàng loạt từ bên thứ 3 thất bại',
    diffTime: "Khoảng thời gian (Số giây lớn hơn hoặc bằng)",
    errStrSearch: "Thông tin phản hồi (Nhập null biểu thị tìm kiếm thông tin phản hồi để ",
    orderDetail: "Chi tiết đơn",
  },
  //第三方账变核查
  systemThirdPartyAmountVerification: {
    platformCode: 'Thuộc nền tảng',
    id: 'ID',
    transferId: 'ID truyền dẫn',
    requestUrl: 'Tên miền',
    type: 'Loại hình',
    status: 'Trạng thái',
    retryCount: 'Số lần thử lại',
    beginTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    lastReqTime: 'Thời gian gửi yêu cầu lần cuối',
    lastRespTime: 'Thời gian gửi phản hồi lần cuối',
    nextReqTime: 'Thời gian gửi yêu cầu lần sau',
    jsonStr: 'Thông tin yêu cầu',
    errStr: 'Thông tin sai sót',
    datetime: 'Thời gian',
    operate: 'Thao tác',
    succeed: 'Thành công',
    fail: 'Thất bại',
    all: 'Tất cả',
    userAccount: 'Tên tài khoản',
    expenses: 'Đặt cược',
    income: 'Trả thưởng',
    refund: 'Hoàn lại',
    frozen: 'Đóng băng',
    thaw: 'Hết đóng băng',
    cancel: 'Hủy đơn',
    settle: 'Giải quyết',
    sum: 'Kiểm tiền',
    auditStatus: 'Trạng thái kiểm duyệt',
    auditRemark: 'Ghi chú kiểm duyệt',
    tabsBtn1: 'Không biến động số dư không mã giao dịch',
    tabsBtn2: 'Có biến động số dư không mã giao dịch',
    tabsBtn3: 'Không biến động số dư có mã giao dịch',
    tabsBtn4: 'Không biến động số dư không mã giao dịch',
    tabsBtn9: 'Đơn đóng băng hết đóng băng bất thường',
    tabsBtn5: 'Chi tiết biến động số dư',
    tabsBtn6: 'Chi tiết giao dịch',
    tabsBtn7: 'Kiểm duyệt',
    tabsBtn8: 'Bù vào',
    radioAuditStatus1: 'Chưa kiểm duyệt',
    radioAuditStatus2: 'Đã kiểm duyệt',
    compensateAmount: 'Số tiền cần bù',
    orderId: 'orderId',
    eventId: 'eventId',
    compensateRemark: 'Ghi chú',
    oId: 'số đơn',
    gameId: 'trò chơi',
    batAuditBtn: 'Kiểm tra hàng loạt',

    placeholderAuditStatus: 'Chọn trạng thái kiểm duyệt',
    placeholderAuditRemark: 'Nhập nội dung kiểm duyệt',
    placeholderCompensateAmount: 'Nhập số tiền cần bù',
    placeholderCompensateRemark: 'Nhập ghi chú bù tiền',
    placeholderEventId: 'Nhập evenId',
    placeholderOId: 'Nhập lệnh đơn gồm 24 ký tự chữ cái và chữ số',
    placeholderFrozen: 'Nhập frozen',
    placeholderPrize: 'Nhập prize',
    placeholderTime: 'Chọn thời gian',
  },
  //第三方对账
  systemThirdPartyReconciliation: {
    date: 'Thời gian',
    platformCode: 'Thuộc nền tảng',
    account: 'Tải khoản',
    betCount: 'Số lần cược (Bên thứ 3/ Biến động số dư)',
    betCount2: 'Lần cược (T đơn cược/J đơn cược/ Bên thứ 3)',
    betAmount: 'Tiền cược (Biến động số dư bên thứ 3/ Biến động số dư/ T đơn cược/J đơn cược/ Đơn cược bên thứ 3)',
    awardSettle: 'Tiền thưởng (Biến động số dư bên thứ 3/ Biến động số dư/ T đơn cược/ J đơn cược/ Đơn cược bên thứ 3)',
    returnCount: 'Lần hoàn tiền (Bên thứ 3/ Biến động số dư/ T đơn cược/J đơn cược)',
    returnAmount: 'Tiền hoàn (Bên thứ 3/ Biến động số dư/T đơn cược/ J đơn cược)',
    awardCount: '活动奖励次数(三方/账变)',
    awardAmount: '活动奖励金额(三方/账变)',
    freezeCount: 'Số lần đóng băng (Bên thứ 3/ Biến động số dư)',
    freezeAmount: 'Số tiền đóng băng (Bên thứ 3/ Biến động số dư)',
    unfreezeCount: 'Số lần hết đóng băng (Bên thứ 3/ Biến động số dư)',
    unfreezeAmount: 'Số tiền hết đóng băng (Bên thứ 3/ Biến động số dư)',
    dataExceptionStatus: 'Trạng thái dữ liệu',
    auditStatus: 'Trạng thái kiểm tra',
    auditRemark: 'Ghi chú',
    handleAmount: 'Số tiền',
    auditUserName: 'Người kiểm tra',
    auditTime: 'Thời gian',
    operate: 'Thao tác',

    all: 'Toàn bộ',
    amountDetail: 'Chi tiết số dư',
    orderDetail: 'Chi tiết đơn',
    radioAuditStatus1: 'Chưa kiểm tra',
    radioAuditStatus2: 'Đã kiểm tra',
    normal: 'Bình thường',
    abnormal: 'Bất thường',
    uncalibrated: 'Chưa kiểm chứng',
    auditBtn: 'Kiểm tra',
    batAuditBtn: 'Kiểm tra hàng loạt',
    dataCheck: 'Đối chiếu số liệu',
    refresh: 'Tải mới dữ liệu bên thứ 3',
    placeholderAuditStatus: 'Chọn trạng thái kiểm tra',
    placeholderAuditRemark: 'Nhập ghi chú',

    compensationAmount: "Số tiền đền bù",
    deductionAmount: "Số tiền đã trừ",
    examine: '异常检查',
    examineResult: '找不到以下结果',
  },
  systemDictManage: {
    code: '字典编码',
    dictValue: '字典名称(CN)',
    dictVieValue: '字典名称(VN)',
    dictEnValue: '字典名称(EN)',
    parentName: '上级字典',
    dictKey: '字典键值',
    sort: '排序',
    isSealed: '封存',
    remark: '字典备注',
    operate: '操作',

    isSealedYes: '是',
    isSealedNo: '否',
    placeholderCode: '请输入字典编码',
    placeholderDictValue: '请输入字典名称(CN)',
    placeholderDictVieValue: '请输入字典名称(VN)',
    placeholderDictEnValue: '请输入字典名称(EN)',
    placeholderSort: '请输入字典排序',
    placeholderRemark: '请输入审核备注',
    placeholderDictKey: '请输入字典键值',
  },
}
